import React from 'react';
import { MarketStructure } from "@/types/market-structure";
import FeatureBox from "../FeatureBox";

const MarketStructureMobile = ({ 
  title, 
  structureData 
}: { 
  title: string;
  structureData: MarketStructure[];
}) => {
  return (
    <div className="container mx-auto px-4">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-black dark:text-white">
          {title}
        </h2>
      </div>

      <div className="mt-6">
        {structureData.map((structure) => (
          <FeatureBox key={structure.id} structure={structure} />
        ))}
      </div>

      {/* No background decorative elements for mobile to keep it lighter */}
    </div>
  );
};

export default MarketStructureMobile; 